module.exports = __webpack_public_path__ + "img/low_icon.1a397a1d.png";